<template>
    <div>
        <b-modal @hidden="close" size="xl" ref="finderModal" :title="prefix + title" hide-footer>
            <TipoOrgaoList :prefix="prefix" @close="tipoOrgaoSelect" />
        </b-modal>
        <lg-form-input-finder v-model="inputValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Tipo de Órgão deve ser informado!" description="" @click:button="show"
            @clear="handleClear">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>

<script>
import TipoOrgaoList from "@/modules/cadastros/tipoorgao/TipoOrgaoList.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";

export default {
    components: { LgFormInputFinder, TipoOrgaoList },
    props: {
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Tipo de Órgão",
        },
    },
    data() {
        return {
            title: "Tipo Orgão",
            inputValue: this.value || null,
        };
    },
    watch: {
        value(newValue) {
            this.inputValue = newValue;
        },
        inputValue(newValue) {
            this.$emit("input", newValue);
        },
    },
    methods: {
        show() {
            this.$refs.finderModal.show();
        },
        handleClear() {
            this.inputValue = {};
            this.$refs.finderModal.hide();
            this.$emit("input");

        },
        close() {
            this.$refs.finderModal.hide();
        },
        tipoOrgaoSelect(item) {
            this.inputValue = item;
            this.$emit("input", item);
            this.$refs.finderModal.hide();
        },
    },
};
</script>
